import {
  Box,
  PrimaryText,
  StyleProps,
  color,
  typography,
  useColorMode,
  useIsMobileView,
} from 'deepstash-ui';
import React from 'react';
import ProfileCard from 'src/components/social/ProfileCard';
import { UserData } from 'types';
import commonStrings from 'utils/strings/commonStrings';
import SubsectionHeader from '../components/SubsectionHeader';
import { GAP_SIZE_REM } from 'utils/global';

interface CuratorSectionProps {
  user: UserData;
}

const CuratorSection: React.FC<CuratorSectionProps & StyleProps> = ({
  user,
  ...props
}) => {
  const { colorMode } = useColorMode();
  const isMobileView = useIsMobileView();

  return (
    <Box {...props}>
      {isMobileView ? (
        <SubsectionHeader pb={GAP_SIZE_REM}>
          {commonStrings.metacontent.curatorSectionHeader}
        </SubsectionHeader>
      ) : (
        <PrimaryText
          {...typography.primaryTextFonts.large.bold}
          color={color[colorMode].textSecondary}
          type="bold"
        >
          {commonStrings.metacontent.curatorSectionHeader}
        </PrimaryText>
      )}
      <ProfileCard user={user} size={'lg'} />
    </Box>
  );
};

export default CuratorSection;
